import * as React from 'react';
import { SVGProps } from 'react';

const IconMailSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 2a1 1 0 0 0-1 1v.835l7 4.888 7-4.888V3a1 1 0 0 0-1-1H2z" />
    <path d="m15 5.054-7 4.89-7-4.89V13a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5.054z" />
  </svg>
);
export default IconMailSizeS;
